import React from 'react'
import { UserSettingsButton } from '../components/UserSettingsButton'

export const EmailPreference = () => {
    return (
        <>
            <h3>Manage your email preferences</h3>
            <p>Click here to manage your email preferences for newsletters</p>
            <UserSettingsButton
                onClick={() => {
                    window.location.href = '/manage-email-preferences'
                }}
                btnType="primary"
                marginLeft={false}
            >
                Go to preference centre
            </UserSettingsButton>
        </>
    )
}
